import { projectStumpsStore, isProjectStumpsHydrated } from "./store";

export const projects = [
  {
    project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
    project_name: "Toronto Infrastructure Project #70",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2026-01-01",
    finish_date: "2026-04-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "Canada",

    community_l2: "Ontario",

    community_l3: "Toronto",

    Community: "Toronto",
  },
  {
    project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
    project_name: "Boston Infrastructure Project #67",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2023-04-02",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "b250c591-6837-1010-2906-15befec3d292",
    project_name: "South Hampton Infrastructure Project #7",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2023-04-1",
    finish_date: "2023-04-13",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
    project_name: "Newport Infrastructure Project #3",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2023-04-01",
    finish_date: "2023-09-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
    project_name: "Salem Infrastructure Project #16",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2023-04-01",
    finish_date: "2023-08-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
    project_name: "Plymouth Infrastructure Project #94",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2023-04-01",
    finish_date: "2023-07-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
    project_name: "Scituate Infrastructure Project #75",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2023-04-01",
    finish_date: "2023-06-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
    project_name: "Westport Infrastructure Project #51",
    project_category: "Infrastructure",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2023-04-01",
    finish_date: "2023-05-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
    project_name: "Dartmouth Infrastructure Project #97",
    project_category: "Infrastructure",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
    project_name: "Arlington Policy Project #56",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
    project_name: "Boston Policy Project #41",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
    project_name: "South Hampton Policy Project #32",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
    project_name: "Newport Policy Project #50",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
    project_name: "Salem Policy Project #35",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
    project_name: "Plymouth Policy Project #16",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
    project_name: "Scituate Policy Project #19",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
    project_name: "Westport Policy Project #34",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
    project_name: "Dartmouth Policy Project #87",
    project_category: "Policy",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
    project_name: "Arlington Policy Project #4",
    project_category: "Policy",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
    project_name: "Boston Social Project #82",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
    project_name: "South Hampton Social Project #65",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
    project_name: "Newport Social Project #3",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
    project_name: "Salem Social Project #10",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
    project_name: "Plymouth Social Project #55",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
    project_name: "Scituate Social Project #61",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
    project_name: "Westport Social Project #19",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
    project_name: "Dartmouth Social Project #82",
    project_category: "Social",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
    project_name: "Arlington Social Project #24",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
    project_name: "Boston Social Project #84",
    project_category: "Social",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
    project_name: "South Hampton Membership Project #61",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
    project_name: "Newport Membership Project #90",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
    project_name: "Salem Membership Project #69",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
    project_name: "Plymouth Membership Project #27",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
    project_name: "Scituate Membership Project #36",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
    project_name: "Westport Membership Project #23",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
    project_name: "Dartmouth Membership Project #36",
    project_category: "Membership",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "84530e7d-f865-267a-4337-a72285000773",
    project_name: "Arlington Membership Project #67",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
    project_name: "Boston Membership Project #70",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
    project_name: "South Hampton Membership Project #12",
    project_category: "Membership",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
    project_name: "Newport Educational Project #20",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
    project_name: "Salem Educational Project #89",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
    project_name: "Plymouth Educational Project #41",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
    project_name: "Scituate Educational Project #68",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
    project_name: "Westport Educational Project #79",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
    project_name: "Dartmouth Educational Project #54",
    project_category: "Educational",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
    project_name: "Arlington Educational Project #27",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
    project_name: "Boston Educational Project #62",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
    project_name: "South Hampton Educational Project #23",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
    project_name: "Newport Educational Project #95",
    project_category: "Educational",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
    project_name: "Salem Economic Project #57",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
    project_name: "Plymouth Economic Project #37",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
    project_name: "Scituate Economic Project #70",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
    project_name: "Westport Economic Project #72",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
    project_name: "Dartmouth Economic Project #27",
    project_category: "Economic",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
    project_name: "Arlington Economic Project #31",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
    project_name: "Boston Economic Project #64",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
    project_name: "South Hampton Economic Project #62",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
    project_name: "Newport Economic Project #19",
    project_category: "Economic",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
    project_name: "Salem Ecology Project #99",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
    project_name: "Plymouth Ecology Project #42",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
    project_name: "Scituate Ecology Project #82",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
    project_name: "Westport Ecology Project #38",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
    project_name: "Dartmouth Ecology Project #86",
    project_category: "Ecology",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
    project_name: "Arlington Ecology Project #22",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
    project_name: "Boston Ecology Project #37",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
    project_name: "South Hampton Ecology Project #61",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
    project_name: "Newport Ecology Project #55",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
    project_name: "Salem Ecology Project #83",
    project_category: "Ecology",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
    project_name: "Plymouth Research Project #57",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
    project_name: "Scituate Research Project #97",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
    project_name: "Westport Research Project #90",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
    project_name: "Dartmouth Research Project #15",
    project_category: "Research",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
    project_name: "Arlington Research Project #51",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
    project_name: "Boston Research Project #8",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
    project_name: "South Hampton Research Project #15",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "New Hampshire",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
    project_name: "Newport Research Project #100",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "d679d948-538e-b268-0696-367116749259",
    project_name: "Salem Research Project #17",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
    project_name: "Plymouth Research Project #72",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
    project_name: "Scituate Research Project #48",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
    project_name: "Westport Research Project #19",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
    project_name: "Dartmouth Research Project #94",
    project_category: "Research",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
    project_name: "Arlington Research Project #42",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
    project_name: "Boston Research Project #47",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
    project_name: "South Hampton Research Project #57",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
    project_name: "Newport Research Project #67",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
    project_name: "Salem Research Project #47",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
    project_name: "Plymouth Research Project #92",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
    project_name: "Scituate Research Project #21",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
    project_name: "Westport Research Project #86",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
    project_name: "Dartmouth Research Project #8",
    project_category: "Research",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Dartmouth",

    Community: "Dartmouth",
  },
  {
    project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
    project_name: "Arlington Research Project #17",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Arlington",

    Community: "Arlington",
  },
  {
    project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
    project_name: "Boston Research Project #71",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Boston",

    Community: "Boston",
  },
  {
    project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
    project_name: "South Hampton Research Project #12",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Regional",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "South Hampton",

    Community: "South Hampton",
  },
  {
    project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
    project_name: "Newport Research Project #19",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Rhode Island",

    community_l3: "Newport",

    Community: "Newport",
  },
  {
    project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
    project_name: "Salem Research Project #19",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "Village",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Salem",

    Community: "Salem",
  },
  {
    project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
    project_name: "Plymouth Research Project #10",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Peer Reviewed",
    project_reach: "Municipal",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Plymouth",

    Community: "Plymouth",
  },
  {
    project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
    project_name: "Scituate Research Project #11",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Global",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Scituate",

    Community: "Scituate",
  },
  {
    project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
    project_name: "Westport Research Project #58",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Under Review",
    project_reach: "National",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "United States",

    community_l2: "Massachusetts",

    community_l3: "Westport",

    Community: "Westport",
  },
  {
    project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
    project_name: "Restoration of Notre Dame",
    project_category: "Research",
    project_status: "Completed",
    content_status: "Peer Reviewed",
    project_reach: "City",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "France",

    community_l2: "Île de France",

    community_l3: "Paris",

    Community: "Paris",
  },
  {
    project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
    project_name: "Martha Court Health Project",
    project_category: "Research",
    project_status: "In Progress",
    content_status: "Reported",
    project_reach: "Home",
    start_date: "2022-01-01",
    finish_date: "2023-12-31",
    budget_estimate: "",
    budget_currency: "USD",
    location_lat: "",
    location_lon: "",
    community_l1: "France",

    community_l2: "Île de France",

    community_l3: "Paris",

    Community: "Paris",
  },
];

// ────────────────────────────────────────────────────────────
// Local-only Project Stumps (bulk import support)
// ────────────────────────────────────────────────────────────
// NO localStorage reads or writes happen in this file.
// All reads/writes use in-memory store with optional API write-through.

function ensureWarm(): void {
  // No-op: localStorage warm-start removed. Data comes from API hydration only.
}

export function getImportedProjectStumps(): any[] {
  ensureWarm();
  return projectStumpsStore.map((p: any) => {
    const o: any = { ...(p || {}) };
    const g = String(o.project_guid || o.project_GUID || o.guid || "").trim();
    if (g) {
      o.project_guid = o.project_guid || g;
      o.project_GUID = o.project_GUID || g;
    }
    return o;
  });
}

export function setImportedProjectStumps(stumps: any[]): void {
  ensureWarm();
  projectStumpsStore.length = 0;
  for (const stump of (stumps || [])) {
    projectStumpsStore.push(stump);
  }
  try {
    window?.dispatchEvent?.(new CustomEvent("l4e_projects_changed"));
  } catch {
    // ignore
  }
}

export function upsertImportedProjectStump(stump: any): void {
  ensureWarm();
  if (!stump) return;
  const guid = String(stump.project_GUID || stump.project_guid || "").trim();
  if (!guid) return;

  const idx = projectStumpsStore.findIndex((p: any) => String(p?.project_GUID || p?.project_guid || "").trim().toUpperCase() === guid.toUpperCase());
  if (idx >= 0) projectStumpsStore[idx] = { ...(projectStumpsStore[idx] || {}), ...stump, project_GUID: guid };
  else projectStumpsStore.push({ ...stump, project_GUID: guid });

  try {
    window?.dispatchEvent?.(new CustomEvent("l4e_projects_changed"));
  } catch {
    // ignore
  }
}

/** Remove locally-imported project stumps by GUID (used for import batch undo). */
export function removeImportedProjectStumpsByGuid(guids: string[]): void {
  ensureWarm();
  const set = new Set((guids || []).map((g) => String(g || "").trim()).filter(Boolean));
  if (set.size === 0) return;

  const next = projectStumpsStore.filter((p: any) => {
    const g = String(p?.project_GUID || p?.project_guid || "").trim();
    return g ? !set.has(g) : true;
  });

  projectStumpsStore.length = 0;
  for (const stump of next) {
    projectStumpsStore.push(stump);
  }

  try {
    window?.dispatchEvent?.(new CustomEvent("l4e_projects_changed"));
  } catch {
    // ignore
  }
}

/**
 * Returns the seed projects from this file plus any locally-imported stumps.
 * This is used by security evaluation and UI lists so imported projects behave like first-class projects.
 */
export function getAllProjectsSeedPlusAdded(): any[] {
  const added = getImportedProjectStumps();
  const seed = Array.isArray(projects) ? projects : [];

  // De-dup by GUID (added wins)
  const byGuid = new Map<string, any>();
  for (const p of seed) {
    const g = String((p as any)?.project_GUID || (p as any)?.project_guid || "").trim();
    if (g) byGuid.set(g, p);
  }
  for (const p of added) {
    const g = String((p as any)?.project_GUID || (p as any)?.project_guid || "").trim();
    if (g) byGuid.set(g, p);
  }
  return Array.from(byGuid.values());
}
